<template>
  <form :action="exportToGoogle" method="POST" target="_blank">
    <c-button
      type="submit"
      :icon="{
        icon: 'google',
        color: 'green',
      }"
      label="Выгрузить в Google таблицы"
      responsive
    />
  </form>
</template>

<script>
import button from "@/components/controls/button";

export default {
  components: {
    "c-button": button,
  },
  props: {
    tableName: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      queryParams: "",
    };
  },
  computed: {
    exportToGoogle() {
      const { userId } = this.$store.state;

      return `/index.php?r=google-sheets/create&user_id=${userId}&table=${this.tableName}&${this.queryParams}`;
    },
  },
  methods: {
    update(params) {
      this.queryParams = params;
    },
  },
};
</script>
